/*
#*===================================================================
#*
#* Licensed Materials - Property of GameTimeFootage Inc.
#*
#* Copyright NextPro 2018. All Rights Reserved.
#*
#*===================================================================
*/

import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import * as fromSharedStore from 'app/shared/store';
import { ResetStore } from 'app/store/actions/reset-store.action';
import { StorageService } from '@shared/services/storage.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent implements OnInit, OnDestroy {
  private componentDestroyed: Subject<any> = new Subject();

  constructor(
    private router: Router,
    private sharedStore: Store<fromSharedStore.SharedState>,
    private storageService: StorageService
  ) {}

  ngOnInit() {
    this.sharedStore.dispatch(new fromSharedStore.UserLogout());
    this.sharedStore.dispatch(new fromSharedStore.ResetPlan());
    this.sharedStore.dispatch(new ResetStore());

    // Set loggedOut token to send message to other opened tabs to log out
    this.storageService.setLogoutToken();

    this.sharedStore
      .select(fromSharedStore.getUser)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((userData) => {
        if (!userData || !userData.id) {
          setTimeout(() => {
            this.router.navigate(['/login']);
          }, 1500);
        }
      });
  }

  ngOnDestroy() {
    this.componentDestroyed.next();
    this.componentDestroyed.complete();
  }
}
